

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Cliente() { return this.Controlador.Pedido.Cliente; }
        public get Envio() { return this.Controlador.Pedido.Envio; }

        public Visible: boolean = false;
        public Ocultar: boolean = false;
        public Cargando: boolean = false;
        public Pedidos: Pedido[] = [];

        async mounted()
        {
            this.Cargando = true;
            await Wait( 1000 );
            this.Pedidos.clear();

            let a = await Pedido.find( { cliente: this.Cliente.Id, limit: 6 } );
            if ( a.Items.hasRows() )
            {
                this.Pedidos = a.Items.filter( x => x.Id != this.Pedido.Id );
            }
            this.Visible = this.Pedidos.hasRows();
            this.Cargando = false;
        }

        public Abrir( pedido: Pedido )
        {
            if ( pedido && pedido.Existe )
            {
                window.open( '/#/pedido/' + pedido.Id );
            }
        }

        public async Descargar( pedido: Pedido )
        {
            Utiles.GenerandoArchivo( true );
            let pdf = await Pedido.URLNotaDeVenta( [pedido] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `Error al generar la nota de venta` );

            }
            Utiles.GenerandoArchivo( false );

        }
    }
